import { render, staticRenderFns } from "./serial-profile.vue?vue&type=template&id=a2bc1d98&scoped=true&"
import script from "./serial-profile.vue?vue&type=script&lang=js&"
export * from "./serial-profile.vue?vue&type=script&lang=js&"
import style0 from "./serial-profile.vue?vue&type=style&index=0&id=a2bc1d98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bc1d98",
  null
  
)

export default component.exports